import { toast } from 'react-toastify';

let ultimoErro = '';

export const useNotificacoes = () => {
    const exibirSucesso = (mensagem) => {
        toast.success(mensagem, {
            position: 'top-right',
            autoClose: 8000,
            theme: 'colored',
        });
    };

    const exibirErro = (mensagem) => {
        if (mensagem === ultimoErro) return;
        ultimoErro = mensagem;

        toast.error(mensagem, {
            position: 'top-right',
            autoClose: 8000,
            theme: 'colored',
            onClose: () => { ultimoErro = ''; }
        });
    };

    const exibirAlerta = (mensagem) => {
        toast.warn(mensagem, {
            position: 'top-right',
            autoClose: 8000,
            theme: 'colored',
        });
    };

    return { exibirSucesso, exibirErro, exibirAlerta };
};
